export default __webpack_public_path__ + "static/media/vilmalogo.d16a3215.png";